// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2r0jP","gfeWrapper":"CalendarEvent_gfeWrapper__38gg9"};